module.exports = __webpack_public_path__ + "img/service-location2.ee54a8c8.svg";